const m = window.require("discourse/models/form-template");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;